var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video__container"},[(_vm.loading)?_c('vimeo-player',{ref:"player",staticClass:"embed-responsive",attrs:{"controls":_vm.contr,"video-id":_vm.id,"options":_vm.options},on:{"play":_vm.play,"pause":_vm.pause}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }